import Marquee from "react-fast-marquee";
import { Flower2 } from "lucide-react";

const WORDS = [
  "Traditional Massage",
  "24 Jam",
  "Bebas Uang Transport",
  "Jogja",
  "Reflexology",
  "Terapis Bersertifikat",
  "Datang ke Tempat Anda",
];

export const Ribbon = () => (
  <div className="bg-[#2c1e16] py-4 sm:py-5">
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-2xl sm:text-3xl text-[#faf7f2] px-6">
            {w}
          </span>
          <Flower2 className="h-4 w-4 text-[#b8862f]" strokeWidth={1.5} />
        </span>
      ))}
    </Marquee>
  </div>
);
